import React from "react";

import ClosetsDescription from "./ClosetsDescription";
import ClosetsSlider from "./ClosetsSlider";
import { Container } from "./styled";

const ClosetsExplanation = () => {
  return (
    <Container>
      <ClosetsDescription />
      <ClosetsSlider />
    </Container>
  );
};

export default ClosetsExplanation;
